import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,[(_vm.isLoggedIn)?_c('dashboard'):_c('auth'),_c(VSnackbar,{attrs:{"color":_vm.notif.color,"timeout":2500},scopedSlots:_vm._u([{key:"action",fn:function({ attrs }){return [_c(VBtn,_vm._b({attrs:{"text":"","color":"white"},on:{"click":function($event){_vm.notif.open = false}}},'v-btn',attrs,false),[_vm._v(" x ")])]}}]),model:{value:(_vm.notif.open),callback:function ($$v) {_vm.$set(_vm.notif, "open", $$v)},expression:"notif.open"}},[_vm._v(" "+_vm._s(_vm.notif.message)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }